const visibleColumns = [
    {
        title: "Supervisor Employee ID",
        field: "SupervisorEmployeeID",
        locked: false,
        filter: "numeric",
        width: "150px",
        show: true,
    },
    {
        title: "Employee Name",
        field: "Employee_Name",
        locked: false,
        filter: "text",
        width: "190px",
        show: true,
    },
    {
        title: "Name",
        field: "Name",
        locked: false,
        filter: "text",
        width: "270px",
        show: true,
    },
    {
        title: "Supervision Role",
        field: "SupervisionRole",
        locked: false,
        filter: "text",
        width: "180px",
        show: true,
    },
    {
        title: "Dept",
        field: "DeptNo",
        className: "text-end",
        locked: false,
        filter: "text",
        width: "180px",
        show: true,
    },
];

export default visibleColumns;
